export enum NotificationCategory {
  Post = 1,
  Chat = 2,
}
